export default "__VITE_ASSET__CnQwaOfA__"